import gql from 'graphql-tag'

//---------------------------- HomePage Queries ---------------------------------

export const homepageQuery = gql`
query homeQuery($alias : JSON, $lang: String ,$location: String) {
  homepages (sort: "displayPosition:asc", where : { alias : $alias, kioskLocationCode_contains : $location }, locale: $lang) {
    id
    speech    
    pageName
    alias
    colLength   
    locale 
    desc
    pageType{
      ... on ComponentHomepageNavigation{
        __typename
        pathName
        pageHeader
      }
      ... on ComponentHomepageDialogBox{
        __typename
        textList      
        type
        mapName
      }
    }
    displayIcon{
      id
      url
    }
  }
}
`

//---------------------------- Faq Page Queries ---------------------------------


export const faqQuery = gql`
query faqQuery($location: String, $lang: String) {
  faqs (start: 0, where : { courtLocationCode_contains : $location}, locale: $lang) {
    id
    showUrl
    urlDetails
    linkId
    question
    answer
    locale
  }
}
`

